import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { EmailTemplatesUpsertPage } from '@/areas/quote-requests/EmailTemplates/EmailTemplateUpsertPage';
import { organizationSettingsEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/email/create')({
    staticData: {
        access: {
            permissions: ['edit:organization_settings'],
            modulePermissions: organizationSettingsEditModulePermissions,
        },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <EmailTemplatesUpsertPage />;
}
